



















import { computed, defineComponent, ref, toRefs, watch } from '@vue/composition-api';
import Clickoutside from 'byted-vui/src/utils/clickoutside';

const name = 'ttam-dropdown-panel';
export default defineComponent({
  name,
  directives: { Clickoutside },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    enabledAutoChangePlacement: {
      type: Boolean,
      default: false,
    },
    dropDownMaxHeight: {
      type: Number,
      default: 274,
    },
    toggle: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const isDropdownTop = ref(false);
    const reference = ref(null);
    const { visible, dropDownMaxHeight, toggle } = toRefs(props);

    const onClose = () => {
      emit('update:visible', false);
    };

    const calcDropdownPostion = () => {
      const referEle = reference.value;
      if (!referEle || !props.enabledAutoChangePlacement) {
        return;
      }
      const { bottom } = referEle.getBoundingClientRect();
      console.log(referEle, referEle.getBoundingClientRect());
      isDropdownTop.value = window.innerHeight - bottom < dropDownMaxHeight.value;
    };

    const dropdownStyle = computed(() => {
      if (isDropdownTop.value) {
        const referEle = reference.value;
        if (!referEle || !props.enabledAutoChangePlacement) {
          return;
        }
        return { bottom: '100%', 'margin-bottom': '5px' };
      }
      return {
        top: '100%',
        'margin-top': '5px',
      };
    });

    const onVisible = () => {
      if (props.disabled) {
        return;
      }
      if (toggle.value) {
        emit('update:visible', !visible.value);
      } else {
        emit('update:visible', true);
      }
    };

    watch(visible, newVal => {
      if (newVal) {
        emit('show');
        calcDropdownPostion();
      }
    });

    return {
      name,
      onClose,
      onVisible,
      reference,
      isDropdownTop,
      dropdownStyle,
    };
  },
});
